import { connect } from 'react-redux';
import { FrameworkActionCreator, NewVehicleActionCreator, VehiclesActionCreator, RDWVehicleActionCreator, AppointmentActionCreator } from 'src/store/states';
import { IStoreState } from 'src/store';
import VinInput from '../VinInput';

const mapStateToProps = (state: IStoreState) => ({
    leftPaneViewOrder: state.Framework.leftPaneViewOrder,
    optionsSelected: state.NewVehicle.NewVehicle,
    decodeData: state.Vehicles.decodedData,
    vehicleSpecs: state.Specs.specs,
    store: state.Framework.store,
    branch: state.Framework.branch,
    apptCust: state.Appointment.ApptCust,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    theme: state.Framework.theme ?? '',
    dialogOpen: state.Framework.vinDialogOpen,
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
});

const mapDispatchToProps = {
    onAddNewVehicle: NewVehicleActionCreator.AddNewVehicle,
    pushToLeftPane: FrameworkActionCreator.pushToLeftPane,
    popFromLeftPane: FrameworkActionCreator.popFromLeftPane,
    decodeVin: VehiclesActionCreator.DecodeVin,
    clearRDWVehicle: RDWVehicleActionCreator.ClearRDWVehicle,
    clearDecodeData: VehiclesActionCreator.ClearDecodeData,
    selectVehicle: VehiclesActionCreator.SelectVehicle,
    updateApptVeh: AppointmentActionCreator.UpdateApptVehicle,
    setVinDialogOpen: FrameworkActionCreator.SetVinDialogOpen,
    clearNewVehicle: NewVehicleActionCreator.ClearNewVehicle,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(VinInput);